<template>
  <div>

    <base-header class="bg-vg-gradient pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mt-2">
        <div class="col-xl-3 col-lg-6">
          <h2 v-text="uniName" style="color: white"></h2>
        </div>
      </div>
      <!-- Card stats -->
      <div class="row mt-2">
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Vizyoner Genç'e Kayıtlı Öğrenci Sayısı"
                      v-loading="uniUserLoading"
                      cardBg="bg-vg-green"
                      :sub-title="uniUserCount"
                      icon="ni ni-active-40"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Vizyoner Genç Üzerinden Yapılan Staj Başvuru Sayısı"
                      v-loading="uniInternLoading"
                      cardBg="bg-vg-purple"
                      :sub-title="internshipApplicantsCount"
                      icon="ni ni-chart-pie-35"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Staj Kabul Alan Öğrenci Sayısı"
                      v-loading="internshipUniAcceptedLoading"
                      cardBg="bg-vg-yellow"
                      :sub-title="internshipUniUserAcceptedCount"
                      icon="ni ni-money-coins"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="VG Staj Programına Başvuru Yapan Öğrenci Sayısı (2022)"
                      v-loading="vgInternAppliedCountLoading"
                      cardBg="bg-vg-blue"
                      :sub-title="vgInternAppliedCount"
                      icon="ni ni-chart-bar-32"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
        </div>

      </div>
      <div class="row mt-2" v-loading="loading">

        <div class="col-xl-3 col-lg-6">
          <stats-card title="VG Staj Programına Kabul Edilen Öğrenci Sayısı (2022)"
                      v-loading="vgInternAcceptedCountLoading"
                      cardBg="bg-vg-blue"
                      :sub-title="vgInternAcceptedCount"
                      icon="ni ni-chart-bar-32"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="KÖK Başvuru Yapan Öğrenci Sayısı (2022)"
                      v-loading="vgKokAppliedCountLoading"
                      cardBg="bg-vg-purple"
                      :sub-title="vgInternAppliedCount"
                      icon="ni ni-active-40"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="KÖK Kabul Alan Öğrenci Sayısı (2022) *"
                      v-loading="vgKokAcceptedCountLoading"
                      cardBg="bg-vg-yellow"
                      :sub-title="vgKokAcceptedCount"
                      icon="ni ni-money-coins"
                      class="mb-4 mb-xl-0"
          >
          </stats-card>
          <span style="color: azure; font-size: 0.8rem"> * Nihai olumlu listesinden çekilen bilgilerdir. Sonradan yedek olarak eklenen-çıkartılan bilgileri içermez. Teyit sağlayınız.</span>

        </div>
      </div>
    </base-header>
    <!--Charts-->
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col-xl-12">
                <p style="font-weight: bold">Detaylar</p>
                <div class="table-responsive" v-loading="loading">
                  <vue-good-table
                      :columns="infoColums"
                      :rows="rows"
                      :paginate="true"
                      :globalSearch="true"
                      :sort-options="{enabled:false}"
                      :pagination-options="{
                      enabled: true,
                      mode: 'records',
                      nextLabel: 'İleri',
                      prevLabel: 'Geri',
                      rowsPerPageLabel: 'Sayfa başı sonuç',
                      pageLabel: 'Sayfa', // for 'pages' mode
                      allLabel: 'Hepsi',
                      ofLabel:'kişi',
                      perPage:10
                    }"
                      styleClass="table table-bordered table-striped">
                    <!--                    <template slot="table-row" slot-scope="props">-->
                    <!--                      <el-button v-if="props.column.field == 'id'" class="mr-1" type="primary" size="mini" plain>Detay-->
                    <!--                      </el-button>-->
                    <!--                    </template>-->
                  </vue-good-table>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
      <!--Tables-->
      <!--End tables-->
    </div>
  </div>


</template>

<script>
// import * as axios from "axios";
import VueGoodTable from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import Vue from 'vue';
import * as axios from "axios";

Vue.use(VueGoodTable);
export default {
  name: "CompanyStatistics",
  data() {
    return {
      uniUserCount: '',
      uniName: '',
      vgInternAcceptedCount: '',
      vgInternAppliedCount: '',
      vgKokAppliedCount: '',
      vgKokAcceptedCount: '',
      internshipApplicantsCount: '',
      internshipUniUserAcceptedCount: '',
      rows: [],
      uniUserLoading: false,
      uniInternLoading: false,
      internshipUniAcceptedLoading: false,
      vgInternAcceptedCountLoading: false,
      vgInternAppliedCountLoading: false,
      vgKokAppliedCountLoading: false,
      vgKokAcceptedCountLoading: false,
      loading: false,
      currentPage: 1,
      currentPageSize: 1,
      dateRange: '',
      university_id: '',
      infoColums: [
        {
          label: 'Başlık',
          field: 'title',
          type: 'string',
          html: false,
        },
        {
          label: 'Detay',
          field: 'sections',
          type: 'string',
          html: false,
        },
      ],

    };
  },
  created() {
    this.university_id = this.$route.params.id;
    this.getUniUserCount();
  },
  methods: {
    dateFilter() {
      if (this.dateRange == '') {
        return 0;
      }
      this.getLastCompanies();
    },
    getUniUserCount() {
      this.uniUserLoading = true;
      this.uniInternLoading = true;
      this.internshipUniAcceptedLoading = true;
      this.vgInternAcceptedCountLoading = true;
      this.vgInternAppliedCountLoading = true;
      this.vgKokAppliedCountLoading = true;
      this.vgKokAcceptedCountLoading = true;

      axios.get("admin/dashboard/uni-stat-data?university_id=" + this.university_id).then(response => {
        this.uniUserLoading = false;
        this.uniUserCount = response.data.uni_user_count[0].uni_user_count_data.toString();
        this.uniName = response.data.uni_name;
      })
          .catch(() => {
            this.$notify.error({
              title: 'Bir hata meydana geldi (Üniversite Üye Sayısı)',
              message: 'Lütfen sayfayı yeniden yükleyin. Eğer hata devam ediyorsa yazılım ekibi ile iletişime geçin.'
            });
          });

      axios.get("admin/dashboard/uni-stat-data-intern-applications?university_id=" + this.university_id).then(response => {
        this.uniInternLoading = false;
        this.internshipApplicantsCount = response.data.uni_intern_applications_count[0].uni_intern_applications_count.toString();
      })
          .catch(() => {
            this.$notify.error({
              title: 'Bir hata meydana geldi (Staj Başvuru Sayısı)',
              message: 'Lütfen sayfayı yeniden yükleyin. Eğer hata devam ediyorsa yazılım ekibi ile iletişime geçin.'
            });
          });

      axios.get("admin/dashboard/uni-intern-applied-count?university_id=" + this.university_id).then(response => {
        this.internshipUniAcceptedLoading = false;
        this.internshipUniUserAcceptedCount = response.data.uni_intern_accepted_count[0].uni_intern_accepted_count.toString();
      })
          .catch(() => {
            this.$notify.error({
              title: 'Bir hata meydana geldi. (Başvuru Kabul Sayıları)',
              message: 'Lütfen sayfayı yeniden yükleyin. Eğer hata devam ediyorsa yazılım ekibi ile iletişime geçin.'
            });
          });

      axios.get("admin/dashboard/uni-vg-intern-applied-count?university_id=" + this.university_id).then(response => {
        this.vgInternAppliedCountLoading = false;
        this.vgInternAppliedCount = response.data.uni_vg_intern_applied_count[0].uni_vg_intern_applied_count.toString();
      })
          .catch(() => {
            this.$notify.error({
              title: 'Bir hata meydana geldi. (Vg Staj Başvuru Sayısı)',
              message: 'Lütfen sayfayı yeniden yükleyin. Eğer hata devam ediyorsa yazılım ekibi ile iletişime geçin.'
            });
          });

      axios.get("admin/dashboard/uni-vg-intern-accepted-count?university_id=" + this.university_id).then(response => {
        this.vgInternAcceptedCountLoading = false;
        this.vgInternAcceptedCount = response.data.uni_vg_intern_accepted_count[0].uni_vg_intern_accepted_count.toString();
      })
          .catch(() => {
            this.$notify.error({
              title: 'Bir hata meydana geldi. (Vg Staj Başvuru Sayısı)',
              message: 'Lütfen sayfayı yeniden yükleyin. Eğer hata devam ediyorsa yazılım ekibi ile iletişime geçin.'
            });
          });

      axios.get("admin/dashboard/uni-kok-applied-count?university_id=" + this.university_id).then(response => {
        this.vgKokAppliedCountLoading = false;
        this.vgKokAppliedCount = response.data.uni_kok_applied_count[0].uni_kok_applied_count.toString();
      })
          .catch(() => {
            this.$notify.error({
              title: 'Bir hata meydana geldi. (KÖK Başvuru Sayısı)',
              message: 'Lütfen sayfayı yeniden yükleyin. Eğer hata devam ediyorsa yazılım ekibi ile iletişime geçin.'
            });
          });

      axios.get("admin/dashboard/uni-kok-accepted-count?university_id=" + this.university_id).then(response => {
        this.vgKokAcceptedCountLoading = false;
        this.vgKokAcceptedCount = response.data.uni_kok_accepted_count[0].uni_kok_accepted_count.toString();
      })
          .catch(() => {
            this.$notify.error({
              title: 'Bir hata meydana geldi. (KÖK Kabul Sayısı)',
              message: 'Lütfen sayfayı yeniden yükleyin. Eğer hata devam ediyorsa yazılım ekibi ile iletişime geçin.'
            });
          });

      axios.get("admin/dashboard/uni-intern-accepted-companies?university_id=" + this.university_id).then(response => {
        this.rows.push({ title:"Staj Kabul Alan Firmalar (Tüm Zamanlar)" , sections: response.data.uni_intern_accepted_companies })
      })
          .catch(() => {
            this.$notify.error({
              title: 'Bir hata meydana geldi. (Staj Kabul Alan Firmalar)',
              message: 'Lütfen sayfayı yeniden yükleyin. Eğer hata devam ediyorsa yazılım ekibi ile iletişime geçin.'
            });
          });

      axios.get("admin/dashboard/uni-kok-applied-sections?university_id=" + this.university_id).then(response => {
        this.rows.push({ title:"KÖK'e Başvuru Yapan Bölümler (2022 İlanı İçin Geçerlidir!)" , sections: response.data.uni_kok_applied_sections })
      })
          .catch(() => {
            this.$notify.error({
              title: 'Bir hata meydana geldi. (KÖK Kabul Sayısı)',
              message: 'Lütfen sayfayı yeniden yükleyin. Eğer hata devam ediyorsa yazılım ekibi ile iletişime geçin.'
            });
          });




    }
  }
}
</script>

<style scoped>

</style>